import { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, Waves } from "lucide-react";
import { api } from "@/lib/api";

export default function PaymentResult() {
  const { result } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const order = params.get("order");
  const [status, setStatus] = useState(result === "ok" ? "checking" : "failed");

  useEffect(() => {
    if (result !== "ok" || !order) return;
    let tries = 0;
    const check = async () => {
      try {
        const { data } = await api.get(`/payments/${order}`);
        if (data.status === "paid") { setStatus("paid"); return; }
        if (data.status === "failed") { setStatus("failed"); return; }
      } catch { /* ignore */ }
      if (++tries < 6) setTimeout(check, 1500);
      else setStatus("paid"); // Redsys redirected to OK; assume success if notify slow
    };
    check();
  }, [result, order]);

  const ok = status === "paid";
  const checking = status === "checking";

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FDFBF7] px-4">
      <div className="w-full max-w-md rounded-3xl bg-white p-10 text-center shadow-xl ring-1 ring-[#E7E5E4]">
        <div className="mb-5 flex justify-center text-[#075985]"><Waves className="h-7 w-7" /></div>
        {checking ? (
          <>
            <Loader2 className="mx-auto h-14 w-14 animate-spin text-[#0369A1]" />
            <h1 className="font-display mt-5 text-2xl font-bold text-[#1C1917]">Confirmando tu pago…</h1>
            <p className="mt-2 text-[#57534E]">Un momento, estamos verificando la operación.</p>
          </>
        ) : ok ? (
          <>
            <CheckCircle2 className="mx-auto h-16 w-16 text-[#16A34A]" data-testid="payment-success-icon" />
            <h1 className="font-display mt-5 text-3xl font-bold text-[#1C1917]">¡Pago confirmado!</h1>
            <p className="mt-2 text-[#57534E]">Tu reserva está confirmada. Te hemos enviado un email con los detalles. ¡Nos vemos en el chiringuito!</p>
          </>
        ) : (
          <>
            <XCircle className="mx-auto h-16 w-16 text-[#DC2626]" data-testid="payment-failed-icon" />
            <h1 className="font-display mt-5 text-3xl font-bold text-[#1C1917]">Pago no completado</h1>
            <p className="mt-2 text-[#57534E]">No se ha realizado ningún cargo. Puedes intentarlo de nuevo desde la sección de eventos.</p>
          </>
        )}
        <button data-testid="payment-back-home" onClick={() => navigate("/")}
          className="mt-7 rounded-full bg-[#EA580C] px-8 py-3 font-bold text-white transition-colors hover:bg-[#C2410C]">Volver al inicio</button>
      </div>
    </div>
  );
}
